import {Component, Input, OnInit,ViewChild} from '@angular/core';
import {FbAuctionCardConfiguration} from './fb-auction-card.configuration';
import { FbAuctionDetailConfiguration } from '../../fb-auction-detail/fb-auction-detail.configuration';
import { FbAuctionDetailService } from '../../fb-auction-detail/fb-auction-detail.service';
import { UserService } from 'src/app/_core/lib/user.service';
import { MeasuringUnitEnum } from 'src/app/_core/classes/BatchPreviewDTO';
import { BatchStatusEnum } from 'src/app/_core/enums/batch-status.enum';



@Component({
    selector: 'fb-auction-card',
    templateUrl: './fb-auction-card.component.html',
    styleUrls: ['./fb-auction-card.component.scss']
})
export class FbAuctionCardComponent implements OnInit {

    @Input() configuration!: FbAuctionCardConfiguration;
    @ViewChild('auctionTimer') auctionTimer: any;

    constructor(private fbAuctionDetailService : FbAuctionDetailService, public userService : UserService) {
    }

    getIsMultipleBatch(): boolean {

        return this.configuration.batch.Quantity > 1;

    }

    ngOnInit() {
    }

    show() {

        const param = FbAuctionDetailConfiguration.create(this.configuration.batch)
        .setImgSeller(this.configuration.imgSeller ?? "")
        
        this.fbAuctionDetailService.show(param)

    }

    getBatchAvailabilityStatusTranslation(status: BatchStatusEnum): string {
        switch (status) {
            case BatchStatusEnum.Suspended:
                return 'Sospeso';
            case BatchStatusEnum.Cancelled:
                return 'Cancellato';
            case BatchStatusEnum.Active:
                return 'Attivo';
            case BatchStatusEnum.Closed:
                return 'Chiuso';
            case  BatchStatusEnum.Approval:
                return 'Approvato'
            case BatchStatusEnum.CancelledBySystem:
                return 'Cancellato'
            default:
                return 'Stato sconosciuto';
        }

    }

    getMeasuringUnitTranslation(status: MeasuringUnitEnum): string {
        switch (status) {
            case MeasuringUnitEnum.Box:
                return 'Scatole';
            case MeasuringUnitEnum.Package:
                return 'Conf.';
            case MeasuringUnitEnum.Weight:
                return 'Kg';
            case MeasuringUnitEnum.Litre:
                return 'Litri';
            default:
                return '';
        }
    }

}
